import { CrudPage, type GridColumnMeta } from '../../components/CrudPage';
import { PermissionControllerService } from '../../api/services/PermissionControllerService';
import type { PermissionDto } from '../../api/models/PermissionDto';

const gridMeta: GridColumnMeta[] = [
  { field: 'id', headerKey: 'permissions.id', width: 80, type: 'number', align: 'Right' },
  { field: 'action', headerKey: 'permissions.action', width: 200 },
  { field: 'description', headerKey: 'permissions.description', width: 400 },
];

export default function PermissionsPage() {

  return (
    <CrudPage<PermissionDto & { id: string }, string>
      titleKey="permissions.title"
      gridMeta={gridMeta}
      fetchData={async () => {
        const permissions = await PermissionControllerService.findAll();
        // Sort permissions alphabetically by action (case-insensitive)
        const sorted = [...permissions].sort((a, b) => 
          (a.action || '').toLowerCase().localeCompare((b.action || '').toLowerCase())
        );
        return sorted.map(p => ({ ...p, id: p.uuid || '' }));
      }}
      allowSorting={true}
      saveData={async () => {}}
      deleteData={async () => {}}
      FormComponent={() => null}
      entityName="permission"
    />
  );
} 